import React from 'react';
import { CbmModal, TabContent, TabGroup } from '@groupelacentrale/contact-storybook';
import CarteDepuis2009 from 'assets/carte-depuis-2009.png';
import CarteDepuis20012009 from 'assets/carte-depuis-2001-2009.png';
import CarteAvant2001 from 'assets/carte-avant-2001.png';
import './RegistrationForm.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const RegistrationHelperModal: React.FC<Props> = ({ isOpen, onClose }) => (
  <CbmModal
    title="3 derniers chiffres du numéro d'identification sur la carte grise"
    isOpen={isOpen}
    size="medium"
    onClose={onClose}
    className="registration-helper-modal"
  >
    <TabGroup defaultSelectedTab={0}>
      <TabContent name="Délivrée après le 15/04/2009">
        <div className="image">
          <img src={CarteDepuis2009} alt="Carte depuis 2009" />
        </div>
      </TabContent>
      <TabContent name="Délivrée entre 2001 et le 14/04/2009">
        <div className="image">
          <img src={CarteDepuis20012009} alt="Carte entre 2001 et le 14/04/2009" />
        </div>
      </TabContent>
      <TabContent name="Délivrée avant 2001">
        <div className="image">
          <img src={CarteAvant2001} alt="Carte avant 2001" />
        </div>
      </TabContent>
    </TabGroup>
  </CbmModal>
);
